<ion-app>
  <div class="main-container">
    <ion-router-outlet></ion-router-outlet>
  </div>
  <app-overlay-loading></app-overlay-loading>
</ion-app>
